import React, { forwardRef, useState, useEffect } from 'react';
import './Mallet.css';

const Mallet = forwardRef(({ onSwing, targetHole }, ref) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isMoving, setIsMoving] = useState(false);

  const handleClick = () => {
    onSwing();
  };

  const handleTouchStart = (e) => {
    e.preventDefault();
    onSwing();
  };

  // Move mallet to target hole position
  useEffect(() => {
    if (targetHole !== null && ref.current) {
      // Get hole position
      const holeElement = document.querySelector(`[data-hole="${targetHole}"]`);
      if (holeElement) {
        const holeRect = holeElement.getBoundingClientRect();
        const holeCenterX = holeRect.left + holeRect.width / 2;
        const holeCenterY = holeRect.top + holeRect.height / 2;
        
        // Get mallet container position
        const malletContainer = ref.current.parentElement;
        const containerRect = malletContainer.getBoundingClientRect();
        
        // Calculate relative position from container
        const relativeX = holeCenterX - containerRect.left - 60; // 60 is half of mallet width
        const relativeY = holeCenterY - containerRect.top - 60; // 60 is half of mallet height
        
        setIsMoving(true);
        setPosition({ x: relativeX, y: relativeY });
        
        // Reset moving state after animation
        setTimeout(() => setIsMoving(false), 1000);
      }
    } else if (targetHole === null) {
      // Return to original position
      setIsMoving(true);
      setPosition({ x: 0, y: 0 });
      setTimeout(() => setIsMoving(false), 500);
    }
  }, [targetHole, ref]);

  return (
    <div className="mallet-container">
      <div 
        ref={ref}
        className={`mallet ${isMoving ? 'moving' : ''}`}
        onClick={handleClick}
        onTouchStart={handleTouchStart}
        style={{
          transform: `translate(${position.x}px, ${position.y}px)`
        }}
      >
        <img 
          className="sprite" 
          style={{width: '85%', bottom: '12%'}} 
          src="/assets/anomapalu.png" 
          alt="hammer"
        />
      </div>
    </div>
  );
});

Mallet.displayName = 'Mallet';

export default Mallet;

